// "CERRAR SESIÓN EN TODAS PARTES" (auditoría de seguridad 2026-09-27, punto 5).
//
// Para cuando alguien sospecha que otra persona entró con su cuenta: cierra
// TODOS los navegadores abiertos con ella —este también—, olvida el
// autenticador de esas sesiones y borra el token de la extensión. Después se
// sale de Microsoft aquí mismo. Lo que no puede hacer es cambiar la contraseña:
// por eso el texto lo pide.
import { useState } from 'react';
import { LogOut } from 'lucide-react';
import { logoutEverywhere } from '../api.js';
import { confirmDialog } from './ui.jsx';

export function CerrarSesionesPanel({ lang }) {
  const es = lang === 'es';
  const [ocupado, setOcupado] = useState(false);
  const [err, setErr] = useState(null);

  const cerrar = async () => {
    const ok = await confirmDialog({
      title: es ? 'Cerrar sesión en todas partes' : 'Sign out everywhere',
      message: es
        ? 'Se cerrarán TODAS las sesiones abiertas con tu cuenta, en cualquier computadora o teléfono, incluida esta. También se desconecta la extensión del navegador. Tendrás que volver a entrar.\n\nSi crees que alguien entró con tu cuenta, cambia también tu contraseña.'
        : 'ALL sessions open with your account will be closed, on any computer or phone, including this one. The browser extension is disconnected too. You will have to sign in again.\n\nIf you think someone got into your account, change your password too.',
    });
    if (!ok) return;
    setOcupado(true); setErr(null);
    try {
      await logoutEverywhere();
      // Esta también: fuera de Microsoft, igual que el botón de salir.
      const salir = window.__deskteAuth?.logout;
      if (salir) salir(); else window.location.reload();
    } catch (e) {
      setErr(e.message);
      setOcupado(false);
    }
  };

  return (
    <div style={{ background: 'var(--c-surface,#0d1c2e)', border: '1px solid var(--c-border,#1a3550)', borderRadius: 12, padding: '1.5rem', marginTop: '1rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '.6rem', marginBottom: '.6rem' }}>
        <LogOut size={16} style={{ color: 'var(--c-red,#ff3d6b)' }} />
        <div style={{ fontSize: '.95rem', fontWeight: 700, color: 'var(--c-white,#eef6ff)' }}>
          {es ? 'Cerrar sesión en todas partes' : 'Sign out everywhere'}
        </div>
      </div>
      <div style={{ fontSize: '.84rem', color: 'var(--c-text2,#7aa3c0)', lineHeight: 1.6, marginBottom: '1rem' }}>
        {es
          ? '¿Crees que alguien más entró con tu cuenta? Esto cierra todas las sesiones abiertas, en cualquier dispositivo, y desconecta la extensión del navegador.'
          : 'Think someone else got into your account? This closes every open session, on any device, and disconnects the browser extension.'}
      </div>
      {err && <div style={{ color: 'var(--c-red,#ff3d6b)', fontSize: '.8rem', marginBottom: '.6rem' }}>{err}</div>}
      <button type="button" onClick={cerrar} disabled={ocupado}
        style={{ padding: '.55rem 1rem', borderRadius: 9, border: '1px solid rgba(255,61,107,.35)', background: 'rgba(255,61,107,.1)', color: 'var(--c-red,#ff3d6b)', fontWeight: 700, fontSize: '.82rem', cursor: ocupado ? 'wait' : 'pointer' }}>
        {ocupado ? (es ? 'Cerrando…' : 'Signing out…') : (es ? 'Cerrar sesión en todas partes' : 'Sign out everywhere')}
      </button>
    </div>
  );
}
